import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Button } from "@/shared/ui/button";
import { Mail, Shield } from "lucide-react";

export default function DataDeletionPage() {
  return (
    <div className="min-h-screen bg-[#1A1A1A] text-white py-8 px-4">
      <div className="max-w-2xl mx-auto space-y-6">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-2">
            <Shield className="h-8 w-8 text-blue-400" />
            <h1 className="text-2xl font-bold">
              Exclusão de Dados - LGPD
            </h1>
          </div>
          <p className="text-gray-300">
            Como solicitar a exclusão dos seus dados pessoais
          </p>
        </div>

        {/* Como Solicitar */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-white">
              <Mail className="h-5 w-5 text-blue-400" />
              Como Solicitar
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-gray-300">
            <div className="space-y-3">
              <div>
                <h3 className="font-semibold text-white mb-1">1. Identifique-se</h3>
                <p className="text-sm">
                  Inclua seu nome completo e e-mail cadastrado na plataforma.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-1">2. Especifique os Dados</h3>
                <p className="text-sm">
                  Indique quais dados você deseja excluir (conta, conteúdo, etc.).
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-1">3. Envie a Solicitação</h3>
                <p className="text-sm">
                  Envie para: <strong className="text-blue-400">contato@popcode.com.br</strong>
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  Assunto: "Solicitação de Exclusão de Dados - LGPD"
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Prazos */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">Prazos</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-300">
            <ul className="space-y-2 text-sm">
              <li>• <strong>Confirmação:</strong> Até 5 dias úteis</li>
              <li>• <strong>Processamento:</strong> Até 15 dias úteis</li>
              <li>• <strong>Exclusão completa:</strong> Até 30 dias úteis</li>
            </ul>
          </CardContent>
        </Card>

        {/* Dados */}
        <Card className="bg-[#2A2A2A] border-gray-700">
          <CardHeader>
            <CardTitle className="text-white">Dados</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-gray-300">
            <div>
              <h4 className="font-semibold text-green-400 mb-2">Serão Excluídos:</h4>
              <ul className="text-sm space-y-1">
                <li>• Dados pessoais (nome, e-mail)</li>
                <li>• Dados de perfil e configurações</li>
                <li>• Conteúdo criado pelo usuário</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-orange-400 mb-2">Podem Ser Mantidos:</h4>
              <ul className="text-sm space-y-1">
                <li>• Dados para cumprimento de obrigações legais</li>
                <li>• Dados de segurança e prevenção de fraudes</li>
              </ul>
            </div>
          </CardContent>
        </Card>

        {/* Call to Action */}
        <div className="text-center">
          <Button 
            size="lg" 
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={() => window.open('mailto:contato@popcode.com.br?subject=Solicitação de Exclusão de Dados - LGPD', '_blank')}
          >
            <Mail className="h-4 w-4 mr-2" />
            Enviar Solicitação por E-mail
          </Button>
        </div>
      </div>
    </div>
  );
}
